// const himalayas = new URL('../images/himalayas.jpg', import.meta.url).toString()
import { usePrefersDarkMode } from "../../shared/use-prefers-dark-mode"
import { useShow } from "../../shared/use-rest"

export function ManagerDashboard() {
  const prefersDarkMode = usePrefersDarkMode()
  let options = ""
  if (prefersDarkMode) {
    options = "?theme=transparent"
  }

  const { data } = useShow(
    "metabase_iframes",
    `crc_manager_dashboard${options}`,
  )

  return (
    <div className="h-screen">
      {data && (
        <iframe src={data} className="inset-0 w-full h-full" title="eyeFrame" />
      )}
    </div>
  )
}
